<script lang="ts" setup>
import { computed } from "vue";

const props = defineProps<{
  title: string;
  open: boolean;
  loading?: boolean;
  width?: "x-small" | "small" | "medium" | "large";
}>();

const emit = defineEmits<{
  "update:open": [boolean];
}>();

const isOpened = computed({
  get() {
    return props.open;
  },
  set(isOpened: boolean) {
    emit("update:open", isOpened);
  },
});
</script>

<template>
  <div class="content">
    <PDialog v-model="isOpened" :width="width" :loading="loading">
      <template #header>
        <div class="header">
          <div class="header-title">
            {{ props.title }}
          </div>
          <button class="header-close-button" @click="isOpened = false">
            <IconCrossMd />
          </button>
        </div>
      </template>
      <div class="body">
        <slot name="content" />
      </div>
      <template #footer>
        <slot name="footer" />
      </template>
    </PDialog>
  </div>
</template>

<style lang="scss" scoped>
.header {
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  padding: 1rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);

  &-title {
    font-size: 16px;
    font-weight: 600;
  }

  &-close-button {
    position: absolute;
    right: 1rem;
  }
}
.body {
  border: 0;
  border-radius: 0 0 16px 16px; // косяки ui кита
  overflow: hidden;
}
</style>
